export const LANG_KEY = "livora_lang";
export const MANUAL_KEY = "livora_lang_manual";

export const SUPPORTED_LANGS = [
  "ar",
  "en",
  "de",
  "tr",
  "ru",
  "es",
  "fr",
  "it",
  "pt",
  "fa",
  "id",
  "ph",
  "el",
  "he",
  "ku",
];

export function normalizeSupportedLang(code) {
  if (!code) return null;
  const base = String(code).trim().split("-")[0].toLowerCase();
  return SUPPORTED_LANGS.includes(base) ? base : null;
}

export function resolveDeviceLanguage() {
  if (typeof navigator === "undefined") return "en";

  const candidates = [
    navigator.language,
    ...(Array.isArray(navigator.languages) ? navigator.languages : []),
  ].filter(Boolean);

  for (const candidate of candidates) {
    const lang = normalizeSupportedLang(candidate);
    if (lang) return lang;
  }

  return "en";
}

/** Existing users: livora_lang without manual flag → treat as manual, keep language. */
export function runLanguageMigration() {
  if (typeof window === "undefined") return;

  try {
    const saved = window.localStorage.getItem(LANG_KEY);
    const manual = window.localStorage.getItem(MANUAL_KEY);
    if (saved && manual !== "1") {
      window.localStorage.setItem(MANUAL_KEY, "1");
    }
  } catch (_) {
    // ignore storage errors
  }
}

export function resolveInitialLanguage() {
  runLanguageMigration();

  if (typeof window === "undefined") return "en";

  try {
    const manual = window.localStorage.getItem(MANUAL_KEY);
    const saved = window.localStorage.getItem(LANG_KEY);

    if (manual === "1") {
      return normalizeSupportedLang(saved) || saved || "en";
    }

    if (!saved) {
      return resolveDeviceLanguage();
    }

    return normalizeSupportedLang(saved) || resolveDeviceLanguage();
  } catch (_) {
    return "en";
  }
}

export function isManualLanguageChoice() {
  if (typeof window === "undefined") return false;

  try {
    return window.localStorage.getItem(MANUAL_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function persistManualLanguage(lang) {
  if (typeof window === "undefined" || !lang) return;

  const normalized = normalizeSupportedLang(lang) || String(lang);
  window.localStorage.setItem(LANG_KEY, normalized);
  window.localStorage.setItem(MANUAL_KEY, "1");
}
